import { Box, CircularProgress } from "@mui/material";

export const CustomLoader = ({ height = "25vh" }: { height?: string }) => {
  return (
    <Box
      display="flex"
      height={height}
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress size={80} sx={{ color: "#FE8836" }} />
    </Box>
  );
};
